import React from "react";
import { Layers, Award, RefreshCw } from "react-feather";

const Blueprint = () => {
	return (
		<section className="bg-white py-16 lg:py-20 px-6">
			<div className="container">
				{/* Top Section - Title and Intro */}
				<div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 mb-16">
					{/* Left Side - Title */}
					<div>
						<h2 className="text-2xl lg:text-3xl xl:text-4xl font-light text-swift-pink leading-tight font-generalSans">
							The Haven Blueprint
						</h2>
					</div>

					{/* Right Side - Intro Paragraph */}
					<div className="flex items-center">
						<p className="text-l text-swift-dark leading-relaxed font-generalSans font-light">
							We are not just a product company. Our secret lies
							in the community powered health ecosystem we are
							building to empower girls to thrive with dignity and
							confidence.
						</p>
					</div>
				</div>

				{/* Bottom Section - Three Content Blocks */}
				<div className="grid grid-cols-1 md:grid-cols-3 gap-8">
					{/* Accessible Menstrual Resources */}
					<div className="overflow-auto bg-swift-pink/10 p-5 rounded-lg h-[300px] md:h-[250px] hover:scale-105 hover:drop-shadow-lg transition-all duration-300 cursor-pointer">
						<div className="w-16 h-16 bg-none rounded-full flex items-center justify-center mb-2">
							<Layers className="w-10 h-10 text-swift-pink" />
						</div>
						<h3 className="text-l font-semi-bold text-swift-dark mb-4 font-generalSans">
							Accessible Menstrual Resources
						</h3>
						<p className="text-swift-dark text-l font-light font-generalSans">
							Our dispenser-based system provides reliable access
							to safe and hygienic products through integrated
							access cards, ensuring periods are never a barrier
							to education.
						</p>
					</div>

					{/* Empowerment & Education */}
					<div className="overflow-auto bg-swift-pink/10 p-5 rounded-lg h-[300px] md:h-[250px] hover:scale-105 hover:drop-shadow-lg transition-all duration-300 cursor-pointer">
						<div className="w-16 h-16 bg-none rounded-full flex items-center justify-center mb-2">
							<Award className="w-10 h-10 text-swift-pink" />
						</div>
						<h3 className="text-l font-semi-bold text-swift-dark mb-4 font-generalSans">
							Empowerment & Education
						</h3>
						<p className="text-swift-dark text-l font-light font-generalSans">
							Our peer-to-peer educational "Haven circles" provide
							a safe space for girls to learn about their bodies,
							share experiences, and build a supportive community.
						</p>
					</div>

					{/* Sustainable Impact */}
					<div className="overflow-auto bg-swift-pink/10 p-5 rounded-lg h-[300px] md:h-[250px] hover:scale-105 hover:drop-shadow-lg transition-all duration-300 cursor-pointer">
						<div className="w-16 h-16 bg-none rounded-full flex items-center justify-center mb-2">
							<RefreshCw className="w-10 h-10 text-swift-pink" />
						</div>
						<h3 className="text-l font-semi-bold text-swift-dark mb-4 font-generalSans">
							Sustainable Impact
						</h3>
						<p className="text-swift-dark text-l font-light font-generalSans">
							Our community-powered model ensures lasting
							solutions through self-sufficiency and sustainable
							practices, creating reliable funding streams for
							continued impact.
						</p>
					</div>
				</div>
			</div>
		</section>
	);
};

export default Blueprint;
